/* eslint-disable react/no-danger */
import Head from 'next/head';
import React from 'react';

import type {
  SchemaBreadCrumbList,
  SchemaCollectionPage,
} from '../../../@types/schema';

export type GoogleSchemaProps = {
  breadcrumbsJSON?: SchemaBreadCrumbList;
  collectionPageSchema?: SchemaCollectionPage;
};

export const SCHEMA_ORG = {
  '@context': 'http://schema.org',
  '@type': 'Organization',
  name: 'Domain',
  url: 'http://www.domain.com.au',
  sameAs: [
    'https://www.facebook.com/domain.com.au',
    'https://twitter.com/domaincomau',
    'https://www.linkedin.com/company/domain-com-au',
  ],
};

const safeJsonForScriptTag = (value: unknown): string =>
  JSON.stringify(value)
    .replace(/</g, '\\u003c')
    .replace(/>/g, '\\u003e')
    .replace(/&/g, '\\u0026')
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029');

/**
 * Make the schema JSON for a view
 * by merging common schemas and page schemas
 */
const makeSchemaJSON = ({
  breadcrumbsJSON,
  collectionPageSchema,
}: GoogleSchemaProps): string => {
  const schemaData: (
    | SchemaBreadCrumbList
    | SchemaCollectionPage
    | typeof SCHEMA_ORG
  )[] = [SCHEMA_ORG];

  if (breadcrumbsJSON) {
    schemaData.push(breadcrumbsJSON);
  }

  if (collectionPageSchema) {
    schemaData.push(collectionPageSchema);
  }

  return safeJsonForScriptTag(schemaData);
};

export const GoogleSchema = ({
  breadcrumbsJSON,
  collectionPageSchema,
}: GoogleSchemaProps): JSX.Element => (
  <Head>
    <script
      title="google-schema"
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: makeSchemaJSON({ breadcrumbsJSON, collectionPageSchema }),
      }}
    />
  </Head>
);
